import React from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';
import Item from './Item';
import { CompleteExpressQueryKiosk_company_categories_items } from '~Scenes/SelfServiceKiosks/Components/useExpressQuery/__queries__';
import GeneralItem from '~Scenes/SelfServiceKiosks/Scenes/Category/Components/Items/GeneralItem';
import { LocalItem } from '~Types';

const Wrapper = styled.div`
  padding: 0 128px;
`;

const Items = styled.div`
  display: flex;
  flex-direction: column;

  @media (orientation: landscape) {
    max-width: 1400px;
    margin: 0 auto;
  }
`;

const BottomGradient = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 272px;
  background: linear-gradient(-180deg, rgba(245, 245, 248, 0) 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
`;

interface Props {
  items: CompleteExpressQueryKiosk_company_categories_items[];
  onClickItem: (id: string, instant?: boolean) => void;
  cartItems: LocalItem[];
}

const SmallItems = ({ items, onClickItem, cartItems }: Props) => {
  const { i18n } = useI18n();
  return (
    <Wrapper>
      <Items>
        {items.map((item) => (
          <GeneralItem
            key={item.id}
            id={item.id}
            description={item.descriptionLang}
            variations={item.modificationGroups}
            upsales={item.upsales}
            image={item?.image?.file.url}
            title={i18n(item.titleLang)}
            onClick={onClickItem}
            cartItems={cartItems}
          />
        ))}
      </Items>
      <BottomGradient />
    </Wrapper>
  );
};

export default SmallItems;
